import React, { useRef } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/db';
import { useStore } from '../store/useStore';
import { useWheelNavigation } from '../hooks/useWheelNavigation';

export const SalaryStructureView = ({ handleItemSelect, selectedIndex, setSelectedIndex }: any) => {
  const scrollRef = useRef(null);
  const activeCompany = useStore(state => state.activeCompany);
  
  const employees = useLiveQuery(
    () => activeCompany ? db.employees.where('companyId').equals(activeCompany.id!).toArray() : []
  ) || [];

  useWheelNavigation(scrollRef, employees.length, setSelectedIndex, false);

  return (
    <div className="flex flex-col w-full h-full bg-white z-20 absolute inset-0 font-sans text-[12px] text-black pb-4">
      <div className="bg-[#1e8585] text-white flex justify-between px-2 py-[2px] font-bold shadow-sm z-10">
        <span className="w-1/3 text-left">Salary Structure</span>
        <span className="w-1/3 text-center">{activeCompany?.name}</span>
        <span className="w-1/3 text-right cursor-pointer hover:text-gray-300" onClick={() => handleItemSelect({ name: 'Quit' })}>✕</span>
      </div>

      <div className="bg-white text-black flex justify-between px-2 py-1 font-bold border-b border-[#aebec8] z-10 shadow-sm">
        <span>Select Employee to Edit Structure</span>
      </div>

      <div className="flex flex-col border-b border-[#aebec8] bg-white text-black font-bold px-2 py-1 shadow-sm">
        <div className="flex w-full">
          <div className="flex-1">Employee Name</div>
          <div className="flex-1">Department</div>
          <div className="flex-1">Status</div>
        </div>
      </div>

      <div ref={scrollRef} className="flex-1 overflow-y-auto bg-white scrollbar-thin pb-6">
        {employees.length === 0 ? (
           <div className="p-8 text-center text-gray-500 font-bold italic">No employees found. Please create employees first.</div>
        ) : (
          employees.map((emp: any, idx: number) => (
            <div 
              key={idx}
              className={`flex w-full px-2 py-[2px] cursor-pointer ${selectedIndex === idx ? 'bg-[#1e8585] text-white font-bold' : 'text-black hover:bg-gray-50'}`}
              onClick={() => handleItemSelect(emp)}
            >
              <div className="flex-1">{emp.name}</div>
              <div className="flex-1">{emp.department}</div>
              <div className="flex-1">{emp.basicSalary ? 'Configured' : 'Not Configured'}</div>
            </div>
          ))
        )}
      </div>

      <div className="flex border-t border-[#aebec8] bg-white h-[22px] w-full shadow-inner absolute bottom-0">
        <div className="flex-1 border-r border-[#aebec8] flex justify-between items-center px-1 cursor-pointer" onClick={() => handleItemSelect({ name: 'Quit' })}>
          <div className="flex items-center space-x-[2px] whitespace-nowrap">
            <span className="text-[#2a62a3] font-bold underline decoration-[#2a62a3] underline-offset-2">Q</span>
            <span className="text-[#2a62a3] font-bold">:</span><span className="text-black leading-none">Quit</span>
          </div>
        </div>
      </div>
    </div>
  );
};
